export default {
  AmazonPayWidget : {
    minWidth: '300px',
    width: '99%',
    maxWidth: '900px',
    minHeight: '250px',
    maxHeight: '400px'
  }
};